import TraversalSessionStore from './TraversalSessionStore'

const initializeTraversalSession = () => new TraversalSessionStore()

export type { default as TraversalSessionStore } from './TraversalSessionStore'
export default initializeTraversalSession
